<template>
	<div class="searchpages">
		<cube-page :title="isSj=='true'?'上架产品查询':'查询'">
			<div slot="content">
				<van-search placeholder="请输入产品名称关键词" v-model="re_value" @search="onSearch" show-action>
					<div slot="action" @click="onSearch">搜索</div>
				</van-search>
				<div style="bottom: 50px;display: flex;position: absolute;top: 114px;flex-direction: row;width: 100%;">
					<div style="background-color: #f8f8f8;width: 8em; overflow: scroll;">
						<van-sidebar v-model="active" @change="onChange">
							<van-sidebar-item v-for="(rd, index) in recommendData" :key="rd.id" :title="rd.name"
								:badge="rd.childlist.length>0?rd.childlist.length:''" />
						</van-sidebar>

					</div>
					<div style="width: 100%; overflow: scroll;" v-if="showdata">
						<van-row gutter="3">
							<van-col span="8" v-for="(rd, index) in recommendData[active].childlist" :key="index">
								<router-link :to="'./leoreList?cid='+rd.id+'&name='+rd.name+'&isSj='+isSj">
									<div class="cate-img" :id="rd.id">
										<div style="width: 100%;height: 0;padding-bottom: 100%;position: relative;">
											<img style="width: 100%;height: 100%;position: absolute;"
												:src="rd.ImageFrist"></img>
										</div>
										<div class="ells"
											:style="'font-size: 0.8em;margin: 0px 0 2px;text-align: center;color:'+ gcfg.TopTextColor+'!important;' ">
											{{rd.name}}
										</div>
									</div>
								</router-link>
							</van-col>
						</van-row>
					</div>

				</div>
				<cube-view></cube-view>
			</div>
		</cube-page>
	</div>
</template>
<script>
	import CubeView from '@/components/TP/cube-view'
	import BottomTabbar from '@/components/TP/BottomTabbar'
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'

	export default {
		components: {
			CubeView,
			CubePage,
			BottomTabbar
		},
		data() {
			return {
				active: this.$route.params.active ? this.$route.params.active : 0,
				recommendData: [],
				showdata: false,
				re_value: '',
				gcfg: [],
				store: null,
				isSj: this.$route.query.isSj
			};
		},
		created() {
			this.store = this.$store.getters.getShop
			this.axios_Request();
		},
		methods: {
			onSearch() {
				//跳转
				let that = this
				// ./leoreList?cid='+rd.id+'&name='+rd.name+'&isSj='+isSj
				this.$router.push({
					path: './leoreList',
					query: {
						name: that.re_value,
						isSj: this.isSj
					}
				})
			},
			onChange(key) {
				this.activeKey = key;
			},
			axios_Request() {
				var url = "/addons/litestore/api.category/Showlist"
				let that = this;
				//util.isToken
				//这里直接调用网络接口
				util.get(url, {
						store_id: that.store.id
					},
					function(result) {
						that.recommendData = result['data']['categorydata']
						that.showdata = true
					},
				);
			}
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			},
			"$store.state.shop"() {
				this.store = this.$store.getters.getShop
			}
		}
	}
</script>

<style scoped="scoped">
	.cube-page {
		background-color: #fff !important;
	}

	.van-badge--select {
		border-color: #6d189e;
	}

	.van-info {
		background-color: #6d189e;
	}

	.van-card__desc {
		max-height: 34px;
		white-space: inherit;
	}

	.van-card__thumb {
		top: 10px;
	}
</style>
